// extracted by mini-css-extract-plugin
export var phone = "_4q-0";
export var phoneDragging = "_4q-1";